import React from "react";
import video from '../img/Winter Video.mp4';


function MediaComponent(){
    return (
        <>
            <video width="100%" height="100%"  preload='auto' autoPlay muted loop>
                <source src={video} type="video/mp4" />
            </video>
        </>
    )
}

export default MediaComponent;